<template>
  <footer class="footer">
    <div class="container-fluid d-flex justify-content-end align-items-center">
      <ul class="nav">
        <li class="nav-item">
          <a class="nav-link" href="mailto:sebastian.trianaduran@hotmail.com">
            Contacto — sebastian.trianaduran@hotmail.com
          </a>
        </li>
      </ul>
    </div>
    <div class="text-right pr-3">
      <small>© {{ year }} · <strong>ConsultIA</strong>. Datos abiertos — datos.gov.co</small>
    </div>
  </footer>
</template>

<script>
export default {
  name: "ContentFooter",
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped>
.footer {
  padding: 10px 15px;
  background-color: transparent;
  font-size: 0.9rem;
  color: #0A2463;
}

.nav-link {
  color: #0A2463 !important;
  font-weight: 500;
  transition: 0.25s ease;
}

.nav-link:hover {
  color: #E63946 !important;
  text-decoration: underline;
}

small {
  color: #64748b;
}
.nav-link {
  color: #0A2463 !important;
  font-weight: 500;
  transition: 0.25s ease;
  text-transform: lowercase;
}
</style>